import { t as translateDate } from './translate-date.js';
import { U as Url } from './url.min.js';
import './index2.js';

/*
 * GHS ibooking
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_214
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new Url(ctx.baseUrl);
        // example url: https://booking.pimalai.com/?do=check&arrival=2020-07-15&departure=2020-07-17&rooms=1&adults=1&children=0&infants=0&promo=Discount+3+%25&nights=2&currency=&group=
        if (ctx.baseUrl.match(/booking\.[^.]+\.com/i)) {
            if (ctx.newData.dateBegin && ctx.newData.dateEnd) {
                ctx.newData.nights = thn.daysBetween(ctx.newData.dateBegin, ctx.newData.dateEnd);
                ctx.newData.dateBegin = ctx.newData.dateBegin.replace(/\//g, '-');
                ctx.newData.dateEnd = ctx.newData.dateEnd.replace(/\//g, '-');
                url.query.nights = '[nights]';
                url.query.arrival = '[date_begin]';
                url.query.departure = '[date_end]';
            }
            url.query.rooms = '[rooms]';
            url.query.adults = '[adults]';
            url.query.children = '[children]';
            url.query.currency = '[currency]';
            ctx.newUrl = url.decode(url.toString());
        }
        else {
            // This is not a valid BE URL
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_214
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        let nights;
        const dateBeginFromUrl = thn.parseUrlParameter('arrival');
        const dateEndFromUrl = thn.parseUrlParameter('departure');
        const dateBeginFromRequestForm = document.querySelector('[name="request[arrival]"]')?.value?.replace(/-/g, '/');
        const dateEndFromRequestForm = document.querySelector('[name="request[departure]"]')?.value?.replace(/-/g, '/');
        const dateBegin = dateBeginFromUrl?.replace(/-/g, '/') || dateBeginFromRequestForm;
        const dateEnd = dateEndFromUrl?.replace(/-/g, '/') || dateEndFromRequestForm;
        thn.logger.debug('<======dateBeginFromUrl=========> Checkin date from dateBeginFromUrl:', dateBeginFromUrl);
        thn.logger.debug('<======dateEndFromUrl=========> Checkout date from dateEndFromUrl:', dateEndFromUrl);
        thn.logger.debug('<======dateBeginFromDatePicker=========> Checkin date from dateBeginFromDatePicker:', dateBeginFromRequestForm);
        thn.logger.debug('<======dateEndFromDatePicker=========> Checkout date from dateEndFromDatePicker:', dateEndFromRequestForm);
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
        }
        if (widgetData.dateBegin && widgetData.dateEnd) {
            // check if the price is per night
            if (((document.querySelector('.rate-name .float-right') || []).textContent || '').match(/night/i)) {
                nights = 1;
            }
            else {
                nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
            }
        }
        const urlAdults = thn.parseNumber(thn.parseUrlParameter('adults'));
        const thnDateAdults = $('input#adults_spinner');
        if (thnDateAdults.length) {
            widgetData.adults = thn.parseNumber(thnDateAdults[0].value) || urlAdults;
        }
        const urlChildren = thn.parseNumber(thn.parseUrlParameter('children'));
        const thnDateChildren = $('input#children_spinner');
        if (thnDateChildren.length) {
            widgetData.children = thn.parseNumber(thnDateChildren[0].value) || thn.parseNumber(document.querySelector('#children_spinner').value) || urlChildren;
        }
        const thnDateRooms = $('input#rooms_spinner');
        if (thnDateRooms.length) {
            widgetData.rooms = thn.parseNumber(thnDateRooms[0].value);
        }
        widgetData.guests = widgetData.adults + widgetData.children;
        // Sometimes we are detecting a wrong price, with an extra number:
        // Correct: 11880.00 THB
        // Wrong: 309825.00 THB -> Should be 30982.5 THB
        // That for the same user, in subsequent searches :(
        // As far as I can tell, selector ".alt-rate-price" always has a good price.
        // Temporarily remove ".total-net-amount" to check if that is the source
        // of the wrong prices ... (2021-06-10 ~ Carles)
        // const prices = $('.total-net-amount, .alt-rate-price');
        const prices = [...document.querySelectorAll('.rate-name .float-right')].map(((price) => thn.parseNumber(price?.innerText?.match(/\b([\d,]+(?:\.\d+)?)\s*\/\s*Night$/)[1]))).filter(Boolean)
            || [...document.querySelectorAll('[name="request[room_rate]"]')].map((el) => el.value);
        const currency = thn.parseCurrency((document.querySelector('.rate-name .float-right') || document.querySelector('.rate-name'))?.textContent?.trim());
        if ((prices.length) && currency) {
            widgetData.price = Math.min(...prices) / nights;
            widgetData.currency = currency;
            widgetData.set = true;
        }
        return widgetData;
    };
    /**
      * @memberOf module:bs_214
      * @this thn.widgets.booking
      * @see {@link Booking#set_data}
      *
      * @param {object} ctx - The context object.
      */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // Price
        const price = $('.summary-table td:contains("Total Amount"):eq(0)').siblings().text().trim();
        widgetData.price = thn.parseNumber(price);
        // Dates
        const dateBegin = $('.summary-table td:contains(Arrival):eq(0)').siblings().text().trim();
        const dateEnd = $('.summary-table td:contains(Departure):eq(0)').siblings().text().trim();
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = translateDate(dateBegin, thn.data.language || 'en');
            widgetData.dateEnd = translateDate(dateEnd, thn.data.language || 'en');
        }
        // Currency
        widgetData.currency = (price && thn.parseCurrency(price)) || $('#currency_options').val();
        // For this BE, we will try to avoid getting the bookingId without getting price and currency
        // the user can access the page later on, and there's no booking data in the HTML (bookingId always present on the URL)
        // if we don't do so, the will send a booking with the bookingId and the PW data which will override the correct data!
        if (widgetData.price && widgetData.currency) {
            // Booking ID
            widgetData.bookingId = thn.parseUrlParameter('booking');
        }
        else {
            // If there's no data (price & currency) we should rely on last_search / PW data or we will have extra bookings with no bookingId
            // we can identify those cases on the DB, checking the url of booking visits we could see the URL repeated on the URL
            widgetData.set = false;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
